import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { prettifyCardNumber, prettifyDate } from '../../../utils/string';
import { transactionShape } from '../../../utils/propTypes';
import {
    cardTypesMapper,
    transactionStatusMapper,
    currencyMapper
} from '@nexio/emvio-util-app';
import { get } from 'lodash';
import ColorDollarAmountCell from '../../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import './FraudListItem.scss';

export default class FraudListItem extends Component {
    static propTypes = {
        item: transactionShape.isRequired,
        onGoToItem: PropTypes.func.isRequired
    };

    renderTransactionLabel(transaction) {
        let left, center = '-';

        if (transaction.cardNumber) {
            left = transaction.cardType ? cardTypesMapper[transaction.cardType].toUpperCase() : 'CARD';
            center = prettifyCardNumber(transaction.cardNumber);
        } else if (transaction.checkNumber) {
            left = 'CHECK';
            center = prettifyCardNumber(transaction.checkNumber);
        }

        return (
            <span className="fraud-label">
                <div>{left}</div>
                <div>{center}</div>
            </span>
        );
    }

    renderResult(transactionStatus) {
        return get(transactionStatusMapper, transactionStatus, '-').toUpperCase();
    }

    render() {
        const fraud = this.props.item;
        const currencyCode = get(currencyMapper, fraud.currencyId, '840').code;

        return (
            <div className="fraud-list-item" onClick={this.props.onGoToItem}>
                <div className="fraud-list-item-left">
                    {this.renderTransactionLabel(fraud)}
                    <span className="fraud-result">{this.renderResult(fraud.transactionStatus)}</span>
                </div>
                <div className="fraud-list-item-right">
                    <span className="fraud-amount">
                        <ColorDollarAmountCell amount={fraud.amount} currencyCode={currencyCode}/>
                    </span>
                    <span className="fraud-date">{prettifyDate(fraud.transactionDate)}</span>
                </div>
            </div>
        );
    }
}
